import styled from "styled-components";

import { CheckboxInterface } from "./intefaces";

import colors from "../../assets/css/colors";

export const Container = styled.div`
    display: flex;
    align-items: center;
    height: 14px;
`;

export const CheckboxSquare = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 14px;
    height: 100%;
    box-shadow: 0px 3px 6px ${colors.checkboxShadow};
    background-color: ${(p: CheckboxInterface) => p.isChecked ? colors.primary : colors.white };
    border: 1px solid ${(p: CheckboxInterface) => p.isChecked ? colors.primary : colors.grayDark};
    border-radius: 3px;
    margin-right: 15px;
`;

export const Label = styled.span`
    line-height: 1;
    font: normal normal normal 14px Circular Std Book;
    height: 15px;
    color: ${colors.grayDark};
    margin: 0;
`;